import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Message } from 'semantic-ui-react';

import Story from 'app/components/Story/';
import modalStyles from 'shared/components/modalStyles';
import MobileCartStory from 'app/components/MobileCartStory/MobileCartStory';
import messages, { FormattedMessage } from 'shared/messages/messages';

import config from 'shared/config/config';
import { setDeeplinkStoryId, openCartStory } from 'shared/actions/storyActions';

const styles = theme => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },
  paper: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  card: {
    maxWidth: 345,
    maxHeight: 345,
  },
  media: {
    height: 300,
  },
  stories: {
    flexGrow: 1,
    background: config.pwa_stories_bg
  },
  fab: {
    color: "primary",
    margin: theme.spacing.unit, // You might not need this now
    position: "fixed",
    bottom: theme.spacing.unit * 1,
    right: theme.spacing.unit * 1,
    height: '75px',
    width: '75px',
    background: '#3e387b'
  },
  icon: {
    fontSize: '2.2rem'
  },
  message: {
    marginTop: '5vh'
  },
  ...modalStyles()
});

class Stories extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      storyId: 0
    };
  }

  shouldComponentUpdate(newProps, newState) {
    return this.props.stories.length !== newProps.stories.length ||
      this.props.isMobileCart !== newProps.isMobileCart ||
      this.props.deeplinkStoryId !== newProps.deeplinkStoryId ||
      this.props.openCartStoryId !== newProps.openCartStoryId
  }

  componentDidMount() {
    let currentUrl = window.location.href;
    if (currentUrl.includes('story')) {
      let lastSlashIndex = currentUrl.lastIndexOf('/');
      let strId = currentUrl.substring(lastSlashIndex + 1, currentUrl.length);
      let id = parseInt(strId);
      if (!isNaN(id)) {
        this.props.setDeeplinkStoryId(id);
      } else {
        this.props.setDeeplinkStoryId(null);
      }
    }
  }

  render() {
    const { classes, theme, isMobileCart, deeplinkStoryId, allStoriesbyId } = this.props;

    // Checking state of premium stories when deeplink provided to mobile cart for error messaging
    // Consumer app doesn't really support deeplinks and deeplinks are only supplied when the users on a single story
    // so error messaging will be based on the presence of valid stories
    let cartMessage = null;
    let level = "blue";
    if (isMobileCart && deeplinkStoryId) {
      let linkedStory = allStoriesbyId[deeplinkStoryId];

      if (linkedStory && linkedStory.disable_mobile_cart) {
        cartMessage = messages.cart_purchase_unavailable;
        level = "red";
      } else if (linkedStory && linkedStory.premium_count <= 0) {
        cartMessage = messages.cart_no_photos_available;
      }
    } else {
      if (this.props.stories.length == 0) {
        cartMessage = messages.cart_no_photos_available;
      }
    }

    if (cartMessage) {
      return (
        <div className={classes.message}>
          <Message
            color={level}
            content={<FormattedMessage {...cartMessage} />}
          />
        </div>
      )
    }

    return (
      <div className={classes.stories}>
        <Grid container spacing={5} style={{ marginTop: "10px" }}>
          {
            this.props.stories.map((story, index) => {
              let deeplink = deeplinkStoryId == story.id;
              return (
                <Grid item xs={12} sm={6} md={3} lg={2} key={index} style={{ maxWidth: '100%' }}>
                  {
                    isMobileCart && story.premium_count > 0 ?
                      <MobileCartStory story={story} deeplink={deeplink} />
                      :
                      <Story
                        story={story}
                        deeplink={deeplink}
                      />
                  }
                </Grid>
              );
            })
          }
        </Grid>
      </div>
    );
  }
}

Stories.propTypes = {
  classes: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object,
  theme: PropTypes.object.isRequired
  //stories: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
  screenDimensions: state.screenReducer.dimensions,
  isMobileCart: state.cartReducer.isMobileCart,
  allStoriesbyId: state.storyReducer.stories.byId,
  openCartStoryId: state.storyReducer.openCartStoryId
});

export default connect(mapStateToProps, { setDeeplinkStoryId, openCartStory })(withStyles(styles, { withTheme: true })(Stories));
